var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"monthly-realisation-price-chart-container"},[_c('canvas',{class:!Object.keys(_vm.local.chartData).length ? 'blur' : '',attrs:{"id":"monthly-realisation-price-chart","width":"400","height":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }